module.exports = __webpack_public_path__ + "static/media/ghost-phone-com-icon.98333815.svg";